module.exports = __webpack_public_path__ + "static/media/index-shop-3.e081f8c1.webp";